import { render, staticRenderFns } from "./ChooseMeasure.vue?vue&type=template&id=6b349d2b&"
import script from "./ChooseMeasure.vue?vue&type=script&lang=js&"
export * from "./ChooseMeasure.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMeasure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports